import { render, staticRenderFns } from "./InvoicePublicResult.vue?vue&type=template&id=6fef4074&scoped=true"
import script from "./InvoicePublicResult.vue?vue&type=script&lang=js"
export * from "./InvoicePublicResult.vue?vue&type=script&lang=js"
import style0 from "./InvoicePublicResult.vue?vue&type=style&index=0&id=6fef4074&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fef4074",
  null
  
)

export default component.exports